module.exports = __webpack_public_path__ + "img/store-app.87b0f8cc.png";